import { IconPack } from '@fortawesome/fontawesome-common-types';
import {
  faAlignLeft,
  faArrowsRotate,
  faArrowUpArrowDown,
  faArrowUpRightFromSquare,
  faC,
  faCalendarDay,
  faChartLine,
  faChartMixedUpCircleDollar,
  faChartSimple,
  faCircleDollar,
  faCirclePlay,
  faClipboardList,
  faCloudExclamation,
  faCode,
  faCog,
  faCompress,
  faContainerStorage,
  faDatabase,
  faEarthAmericas,
  faEnvelopeOpen,
  faExternalLinkAlt,
  faFileLines,
  faFilm,
  faFloppyDisk,
  faFloppyDisks,
  faFolderClosed,
  faGlobe,
  faHardDrive,
  faHouseBlank,
  faICursor,
  faInputText,
  faKey,
  faLayerGroup,
  faLifeRing,
  faLocationDot,
  faMicrochipAi,
  faMonitorWaveform,
  faNetworkWired,
  faPhotoFilm,
  faQuestionCircle,
  faScaleBalanced,
  faShieldCheck,
  faSignHanging,
  faSliders,
  faTowerBroadcast,
  faTrashCan,
  faUpRightAndDownLeftFromCenter,
  faUserGroup,
  faVolume,
  faWandMagicSparkles,
} from '@fortawesome/pro-duotone-svg-icons';

export const proDualToneSvgIconsPack: IconPack = {
  faAlignLeft,
  faArrowsRotate,
  faArrowUpArrowDown,
  faArrowUpRightFromSquare,
  faC,
  faCalendarDay,
  faChartLine,
  faChartMixedUpCircleDollar,
  faChartSimple,
  faCircleDollar,
  faCirclePlay,
  faClipboardList,
  faCloudExclamation,
  faCode,
  faCog,
  faCompress,
  faContainerStorage,
  faDatabase,
  faEarthAmericas,
  faEnvelopeOpen,
  faExternalLinkAlt,
  faFileLines,
  faFilm,
  faFloppyDisk,
  faFloppyDisks,
  faFolderClosed,
  faGlobe,
  faHardDrive,
  faHouseBlank,
  faICursor,
  faInputText,
  faKey,
  faLayerGroup,
  faLifeRing,
  faLocationDot,
  faMicrochipAi,
  faMonitorWaveform,
  faNetworkWired,
  faPhotoFilm,
  faQuestionCircle,
  faScaleBalanced,
  faShieldCheck,
  faSignHanging,
  faTowerBroadcast,
  faTrashCan,
  faUpRightAndDownLeftFromCenter,
  faUserGroup,
  faVolume,
  faWandMagicSparkles,
  faSliders,
};
